import React from 'react';
import { QUESTION_TYPES, CONTENT_TYPES } from 'shared/constants/survey';
import Icon, {
  EditOutlined, LikeOutlined, SmileOutlined, CheckSquareOutlined,
  MailOutlined,
  HeartOutlined, FlagOutlined, HomeOutlined,
  GroupOutlined, BorderVerticleOutlined, AlignLeftOutlined, QuestionCircleOutlined,
} from '@ant-design/icons';

const Radio = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="8" cy="8" r="3" fill="currentColor" />
  </svg>
);

const Grade = () => (
  <svg width="1em" height="1em" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="128" cy="128" fill="none" r="120" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20" />
    <polyline fill="none" points="108 100 132 84 132 176" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20" />
  </svg>
);

const RadioIcon = <Icon component={Radio} />;
const GradeIcon = <Icon component={Grade} />;

const icons = {
  [CONTENT_TYPES.BLOCK]: <GroupOutlined />,
  [CONTENT_TYPES.TEXT]: <AlignLeftOutlined />,
  [CONTENT_TYPES.PAGE_BREAK]: <BorderVerticleOutlined />,
  [QUESTION_TYPES.FIELD]: <EditOutlined />,
  [QUESTION_TYPES.CHECKBOX]: <CheckSquareOutlined />,
  [QUESTION_TYPES.ZIP]: <HomeOutlined />,
  [QUESTION_TYPES.COUNTRY]: <FlagOutlined />,
  [QUESTION_TYPES.CONTACT]: <MailOutlined />,
  [QUESTION_TYPES.SENTIMENT]: <SmileOutlined />,
  [QUESTION_TYPES.THUMBS]: <LikeOutlined />,
  [QUESTION_TYPES.NPS]: <HeartOutlined />,
  [QUESTION_TYPES.RADIO]: RadioIcon,
  [QUESTION_TYPES.FIND]: RadioIcon,
  [QUESTION_TYPES.GRADE]: GradeIcon,
};

const ContentTypeIcon = ({ type }) => icons[type] || <QuestionCircleOutlined />;

export default ContentTypeIcon;
